// extracted by mini-css-extract-plugin
export default {"wrapper":"rp-z","response":"sp-z","error":"tp-z","disabled":"up-z","buttons":"vp-z","feedbackQuestionSection":"wp-z","yesNoWrapper":"xp-z"};